
var config = {
    radius: formatNumber(45),
    fontSize: formatNumber(11),
    pieChartLinePadding: formatNumber(15),
    pieChartTextPadding: formatNumber(15),
    lineCircleColor: '#C3F3F3',
    lineCircleWidth: formatNumber(2),
    lineCircleRadius: 1.2,
    margin: formatNumber(4),
    curveWidth: 1,
    curveCirclrRadius: formatNumber(2),
    textMargin: formatNumber(6)
}
function formatNumber(num) {
    const res = wx.getSystemInfoSync()
    const windowWidth = res.windowWidth
    const px_proportion = windowWidth / 375
    return px_proportion * num
}
function convertCoordinateOrigin(x, y, center) {
    return {
        x: center.x + x,
        y: center.y - y // canvas y轴向下递增
    }
}
function getPieDataPoints(series, process) {
    var count = 0
    var _start_ = 0
    series.forEach((item) => {
        item.data = item.data === null ? 0 : Number(item.data)
        count += item.data;
    })
    series.forEach((item) => {
        item._proportion_ = item.data / count * process
        item._start_ = _start_ // _start_进度条开始的位置
        _start_ += 2 * item._proportion_ * Math.PI
    })
    return series;
}
function drawTitleText (opts, options= {}, context) {
    const title = options.name || ''
    const titlefontSize = options.fontSize
    const titleFontColor = options.color
    context.setFontSize(titlefontSize)
    const textWidth = context.measureText(title).width
    const textHeight = title ? titlefontSize : 0
    const startX = (opts.width - textWidth) / 2
    let startY = (opts.height + titlefontSize) / 2
    if (opts.title && opts.title.name === options.name) {
        startY -= (textHeight + config.margin) / 2
    }
    if (opts.subtitle && opts.subtitle.name === options.name ) {
        startY += (textHeight + config.margin) / 2
    }
    context.setFontSize(titlefontSize)
    context.setFillStyle(titleFontColor)
    context.fillText(title, startX, startY)
}
function drawRingTitle(opts, context) {
    if (opts.title) drawTitleText(opts, opts.title, context)
    if (opts.subtitle) drawTitleText(opts, opts.subtitle, context)
}

function drawPieText(series, config, context, radius, center) {
    const lineRadius = radius + config.pieChartLinePadding // 结束点画圆的半径
    let textObjectCollection = []

    const seriesConvert = series.map((item) => {
        const arc = 2 * Math.PI - (item._start_ + 2 * Math.PI * item._proportion_ / 2) // 进度条弧度中间位置
        const text = (item._proportion_ * 100).toFixed(1) + '%'
        const color = item.color;
        return { arc: arc, text: text, name: item.name, color: color };
    })

    seriesConvert.forEach((item) => {
        // 以（0,0）为圆心的逻辑坐标系
        // line end 控制点
        const orginX1 = Math.cos(item.arc) * lineRadius
        const orginY1 = Math.sin(item.arc) * lineRadius
        // line start
        const orginX2 = Math.cos(item.arc) * radius
        const orginY2 = Math.sin(item.arc) * radius
        // text start
        let orginX3 = orginX1 >= 0 ? orginX1 + config.pieChartTextPadding : orginX1 - config.pieChartTextPadding
        const orginY3 = orginY1

        context.setFontSize(config.fontSize)
        const textWidth = context.measureText(item.text).width
        const nameWidth = context.measureText(item.name).width
        const widthOffset = Math.abs(textWidth - nameWidth)
        const startY = orginY3 // y轴方向对齐
        if (orginX3 < 0) {  // 在x的负半轴
            orginX3 -= Math.max(textWidth, nameWidth)
        }
        const textObject = {
            lineStart: {
                x: orginX2,
                y: orginY2
            },
            lineEnd: {
                x: orginX1,
                y: orginY1
            },
            // 重叠文字整坨
            textStart: {
                x: orginX3,
                y: startY
            },
            width: Math.max(textWidth, nameWidth),
            widthOffset: widthOffset,
            text: item.text,
            name: item.name,
            color: item.color
        }
        textObjectCollection.push(textObject)
    })

    textObjectCollection.forEach((item) => {
        // 将逻辑坐标转换为canvas坐标
        const lineStartPoistion = convertCoordinateOrigin(item.lineStart.x, item.lineStart.y, center)
        const lineEndPoistion = convertCoordinateOrigin(item.lineEnd.x, item.lineEnd.y, center)
        const textPosition = convertCoordinateOrigin(item.textStart.x, item.textStart.y, center)

        context.setAttribute('witdh', config.curveWidth)
        context.setFontSize(config.fontSize)
        context.beginPath()
        context.setStrokeStyle(item.color)
        context.setFillStyle(item.color)
        context.moveTo(lineStartPoistion.x, lineStartPoistion.y)

        var curveStartX = item.textStart.x < 0 ? textPosition.x + item.width : textPosition.x //结束点

        var textStartX = item.textStart.x < 0 ? textPosition.x - config.textMargin : textPosition.x + config.textMargin
        var nameStartX = textStartX
        textStartX += item.widthOffset / 2 // 居中
        context.quadraticCurveTo(lineEndPoistion.x, lineEndPoistion.y, curveStartX, textPosition.y)
        context.stroke()
        context.closePath()

        // 开始画线条结束位置的圆点
        context.beginPath()
        context.moveTo(curveStartX, textPosition.y)
        context.arc(curveStartX, textPosition.y, config.lineCircleWidth, 0, 2 * Math.PI)
        context.closePath()
        context.fill()

        // 写百分比
        context.setFillStyle('#333333')
        // 将百分比放置在 series name 的下面 所以在 y 轴上 + config.fontSize
        context.fillText(item.text, textStartX, textPosition.y + config.fontSize)

        // 写name
        context.setFillStyle('#999999')
        context.fillText(item.name, nameStartX, textPosition.y - config.margin)
    });
}

function drawPieDataPoints(opts, config, context, process) {
    var offsetAngle = opts.extra.offsetAngle || 0
    var series = getPieDataPoints(opts.series, process)

    var centerPosition = {
        x: opts.width / 2,
        y: opts.height / 2
    };
    // 半径
    var radius = config.radius

    // 画外圆圈
    var angle = offsetAngle * Math.PI / 180
    context.beginPath()
    context.setAttribute('witdh', config.lineCircleWidth)
    // context.setLineWidth(config.lineCircleWidth)
    context.setStrokeStyle(config.lineCircleColor)
    context.arc(centerPosition.x, centerPosition.y, radius * config.lineCircleRadius, angle, angle + 2 * process * Math.PI)
    context.stroke()

    //画饼图
    series.forEach(function (eachSeries) {
        eachSeries._start_ += offsetAngle * Math.PI / 180

        context.beginPath()
        context.setAttribute('witdh', 2)
        // context.setLineWidth(2)
        context.setFillStyle(eachSeries.color)
        context.moveTo(centerPosition.x, centerPosition.y)
        context.arc(centerPosition.x, centerPosition.y, radius, eachSeries._start_, eachSeries._start_ + 2 * eachSeries._proportion_ * Math.PI)
        context.closePath()
        context.fill()
    })

    var innerPieWidth = radius - opts.extra.ringWidth
    context.beginPath()
    context.setFillStyle(opts.background || '#ffffff')
    context.moveTo(centerPosition.x, centerPosition.y)
    context.arc(centerPosition.x, centerPosition.y, innerPieWidth, 0, 2 * Math.PI)
    context.closePath()
    context.fill()
    // 画图结束后开始画字
    if (process === 1) {
        drawRingTitle(opts, context)
        drawPieText(series, config, context, radius, centerPosition)
    }
}
// 动画
function Animation(opts) {
    let timer
    var startTimeStamp = null
    var delay = 16 //每16毫秒画一帧，一共画16/1000次画完
    function _step(timestamp) {
        if (startTimeStamp === null) {
            startTimeStamp = timestamp
        }
        if (timestamp - startTimeStamp < opts.duration) {
            var process = (timestamp - startTimeStamp) / opts.duration;
            process = timingFunction(process)
            opts.onProcess && opts.onProcess(process)
            timer = animationFrame(_step, delay)
        } else {
            opts.onProcess && opts.onProcess(1)
            timer && clearTimeout(timer)
        }
    }
    timer = animationFrame(_step, delay)
}

function animationFrame(step, delay) {
    var timer = setTimeout(() => {
        step(+new Date()) //最新时间戳
    }, delay)
    return timer
}

function timingFunction(pos) { //easeInOut
    const coefficient = 0.5
    if ((pos /= coefficient) < 1) {
        return coefficient * Math.pow(pos, 3)
    }
    return coefficient * (Math.pow(pos - 2, 3) + 2)
}

function Charts(opts) {
    const context = wx.createCanvasContext(opts.canvasId, opts.self)
    // const cans = document.getElementById("lineCanvas")
    // const context = cans.getContext('2d')
    console.log(context);
    config.radius = formatNumber(opts.height) / 2 * 0.5
    opts.height = formatNumber(opts.height)
    opts.extra.ringWidth = formatNumber(opts.extra.ringWidth)
    opts.title.fontSize = formatNumber(opts.title.fontSize)
    opts.subtitle.fontSize = formatNumber(opts.subtitle.fontSize)
    Animation({
        duration: 1000,
        onProcess: (process) => { // onProcess 画一帧, process: 0~1
            drawPieDataPoints(opts, config, context, process)
            context.draw()
        }
    });
}

export default Charts